export interface CmsStringProperty {
  value?: string | null
}

/**
 * Visible text of a CMS-authored heading field, `''` when the author left it blank.
 * Guard the heading element on this — an empty `<h2>`/`<h3>` fails WCAG 1.3.1.
 */
export function headingText(field?: CmsStringProperty | null): string {
  return `${field?.value ?? ''}`.trim()
}
